module.exports = __webpack_public_path__ + "img/2018.d94a110d.svg";